// Provides global fallback WITHOUT messing with pdfjs or Rollup filenames
if (typeof (globalThis as any).global === "undefined") {
  (globalThis as any).global = globalThis;
}